<ng-container *ngIf="block && block.length">
    <div class="d-flex flex-wrap justify-content-center align-items-stretch container container-feature no-print">
        <div *ngFor="let item of block" class="pe-3 {{ classColumn }} d-flex flex-column justify-content-between bb-custom">
            <div class="feature">
                <div *ngIf="item.lettera" class="letter text-garamond" [innerHTML]="item.lettera"></div>
                <div *ngIf="item.titolo" class="title">
                    <p class="mt-2 ls-label-large-bold text-brand-10" [innerHTML]="item.titolo"></p>
                </div>
                <div *ngIf="item.descrizione" class="description">
                    <p class="text-neutral-40" [innerHTML]="item.descrizione"></p>
                </div>
            </div>
            <div *ngIf="item.label_cta && item.link_cta" class=" d-flex cta_feature line-discover-with-icon">
                <a *ngIf="!nodeService.verifyLinkExternal(item.link_cta.url)" [routerLink]="navigationService.splitUrlRouterLink(item.link_cta.url).path" [queryParams]="navigationService.splitUrlRouterLink(item.link_cta.url).queryParams">
                    <p class="m-0 pb-1 cta_feature__cta ls-label-medium-semibold text-brand-40 text-uppercase"
                        [innerHTML]="item.label_cta"></p>
                </a>
                <a *ngIf="nodeService.verifyLinkExternal(item.link_cta.url)" [href]="item.link_cta.url">
                    <p class="m-0 pb-1 cta_feature__cta ls-label-medium-semibold text-brand-40 text-uppercase"
                        [innerHTML]="item.label_cta"></p>
                </a>
                <i class="fa-solid fa-arrow-right text-brand-40 pb-4" aria-hidden="true"></i>
            </div>
        </div>
    </div>
    <ng-container *ngFor="let item of block">
        <app-sample-print [title]="item.lettera" [subtitle]="item.titolo" [description]="item.descrizione"></app-sample-print>
    </ng-container>
</ng-container>